import GoogleTagManager from './googleTagManager';
import { EventScope } from '@openticket/lib-eventbus';
/**
 * Collection of methods for emitting events and initializing
 * trackers.
 */
export default class Tracking extends EventScope {
    constructor(eventBus) {
        super(eventBus);
        this._gtmContainers = [];
        this.addHistoryChannel();
    }
    /**
     * Add a Google Tag Manager instance to the project
     * @param gtmCode - Google Tag Manager identifier
     * @todo
     */
    addGoogleTagManager(gtmCode) {
        this._gtmContainers.push(new GoogleTagManager(gtmCode, this._eventBus, this._gtmContainers.length));
    }
    /**
     * Should be triggered on `filter` events. E.g. when selecting an event of time scope
     */
    filter(name, shop, filter, items) {
        this.emit(['shop', 'impression', 'filter', name], {
            shop: {
                guid: shop.guid,
                name: shop.name,
            },
            filter,
            items: items.map((ticket) => {
                return {
                    id: ticket.guid,
                    name: ticket.name,
                    price: ticket.pricing.total_price,
                };
            }),
        });
    }
    /**
     * Should be triggered when the booker information is visible
     */
    details(shop, items) {
        this.emit(['shop', 'impression', 'details'], {
            shop: {
                guid: shop.guid,
                name: shop.name,
            },
            items: items.map((item) => {
                return {
                    id: item.item.guid,
                    name: item.item.name,
                    price: item.pricing.total_price,
                };
            }),
        });
    }
    /**
     * Should be triggered when the payment method overview becomes visible
     */
    payment(shop, items) {
        this.emit(['shop', 'impression', 'payment'], {
            shop: {
                guid: shop.guid,
                name: shop.name,
            },
            items: items.map((item) => {
                return {
                    id: item.item.guid,
                    name: item.item.name,
                    price: item.pricing.total_price,
                };
            }),
        });
    }
    /**
     * Fire router events for all url changes
     */
    addHistoryChannel() {
        let oldHref = document.location.href;
        window.onload = () => {
            const bodyList = document.querySelector('body');
            const observer = new MutationObserver((mutations) => {
                mutations.forEach(() => {
                    if (document && document.location && oldHref != document.location.href) {
                        const parser = document.createElement('a');
                        parser.href = document.location.href;
                        const parts = parser.pathname.split('/');
                        parts.splice(0, 1);
                        this.emit(['router', ...parts], {
                            old: oldHref,
                            new: document.location.href,
                        });
                        oldHref = document.location.href;
                    }
                });
            });
            const config = {
                childList: true,
                subtree: true,
            };
            if (!bodyList) {
                throw new Error('No body found');
            }
            observer.observe(bodyList, config);
        };
    }
}
//# sourceMappingURL=tracking.js.map